<template>
  <div id="withdraw-payroll">
    <!-- 顶部导航栏 -->
    <van-nav-bar :title="$t('title.withdraw_payroll')" placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col span="22" offset="1" class="payment-card">
        <van-col span="22" offset="1">
          <van-col span="4" class="payment-icon">
            <img src="../assets/img/withdraw_payroll_money.png"/>
          </van-col>
          <van-col span="11">
            <van-col span="24" class="payment-label">{{ $t('column.payment_amount') }}</van-col>
            <van-col span="24" class="payment-amount">$ {{ payroll_seller.payment_amount }}</van-col>
          </van-col>
          <van-col span="9" @click="showTimeFilter">
           <div class="time-filter">  {{ CalendarText }} <van-icon name="arrow-down" size="12" /></div>
          </van-col>
        </van-col>
        <van-col span="22" offset="1">
          <van-col span="12" class="income-item">
            <van-col span="24" class="income-label">{{ $t('other.profit')}}</van-col>
            <van-col span="24" class="income-value">
              <img src="../assets/img/coin9.png"/> {{ payroll_seller.received_amount }}
            </van-col>
          </van-col>
          <van-col span="12" class="income-item">
            <van-col span="24" class="income-label">{{ $t('column.frozen_funds') }}</van-col>
            <van-col span="24" class="income-value">
              <img src="../assets/img/coin9.png"/> {{ payroll_seller.frozen_amount }}
            </van-col>
          </van-col>
        </van-col>
      </van-col>
      <!-- 失败订单信息 -->
      <van-col span="22" offset="1" class="failed-orders">
        <van-col span="20">
          {{ $t('column.failed_orders_month') }}: <span class="failed-orders-number">{{ payroll_seller.withdrawal_failed_number }}</span>
        </van-col>
        <van-col span="4" class="failed-arrow">
          <van-icon name="arrow" size="14" />
        </van-col>
      </van-col>
      <!-- Tab导航 -->
      <van-col span="22" offset="1">
        <van-col span="20">
          <van-tabs v-model="OrderStatusActive" @click="switchTab" :ellipsis="false">
            <van-tab v-for="(item,i) in OrderStatusList" :key="i" :title="OrderStatusText(item)" title-inactive-color="#5E5D65" title-active-color	="#1A1A1A"> </van-tab>
          </van-tabs>
        </van-col>
        <van-col span="4" class="tab-search">
          <van-icon name="search" size="18px" color="#1A1A1A" @click="SearchHref"/>
        </van-col>
      </van-col>
      <van-col span="24" class="withdraw-payroll-order-bg">
        <van-col span="22" offset="1">
          <!-- 警告提示 -->
          <van-col span="24" class="warning-notice" v-if="showWarning">
            <van-col span="3" class="warning-icon">
              <van-icon name="warning-o" color="#ff9500" size="16" />
            </van-col>
            <van-col span="19" class="warning-text"> {{ $t('column.finish_payment_before_countdown')}} </van-col>
            <van-col span="2" class="close-warning" @click="closeWarning">
              <van-icon name="cross" size="16" />
            </van-col>
          </van-col>
          <!-- 订单控制区域 -->
          <van-col span="24">
            <van-col span="11" class="take-order-section">
              <van-col span="22" offset="1" class="control-label">{{ $t('column.take_order_now') }}</van-col>
              <van-col span="20" offset="2" class="toggle-switch">
                <van-switch v-model="takeOrderEnabled" active-color="#FF61F5" size="18px" @input="onInputSwitch" />
              </van-col>
            </van-col>
            <van-col span="12" offset="1" class="take-order-section" @click="selectPaymentMethod">
              <van-col span="18" offset="1" class="control-label">{{ $t('column.payment_method') }}</van-col>
              <van-col span="4" class="method-arrow">
                <van-icon name="arrow" size="16px" active-color="#1A1A1A" inactive-color="#dcdee0"/>
              </van-col>
              <van-col span="20" offset="2" class="take-order-section-img">
                <img :src="t" v-for="(t,i) in payment_method_list" :key="i" />
              </van-col>
            </van-col>
          </van-col>
          <!-- 订单列表 -->
          <van-col span="24" v-if="orders.length > 0">
            <van-list
                v-model="loading"
                :finished="finished"
                :finished-text="$t('other.there_is_no_more')"
                :loading-text="$t('other.Loading')"
                @load="onLoad"
            >
              <van-cell  class="order-item" v-for="(o, index) in orders" :key="index" >
                <van-col span="22" offset="1" class="order-item-content">
                  <van-col span="24" class="info-row">
                    <van-col span="10" class="info-label">{{ $t('column.Platform_id') }}:</van-col>
                    <van-col span="14" class="info-value">{{ o.order_id }}</van-col>
                  </van-col>
                  <van-col span="24" class="info-row">
                    <van-col span="12" class="info-label">{{ $t('column.amount_details') }}:</van-col>
                    <van-col span="12" class="info-value">${{ o.dollar_amount }} = <img src="../assets/img/coin9.png" class="info-value-img"/>{{ o.received_amount }}</van-col>
                  </van-col>
                  <van-col span="24" class="info-row"  v-if="o.user_currency_code">
                    <van-col span="12" class="info-label">{{ $t('column.local_currency') }}:</van-col>
                    <van-col span="12" class="info-value">
                      <img :src="o.user_country_img" class="info-value-img" v-if="o.user_country_img"/>
                      <span> {{ o.user_currency_code }} {{ o.user_local_amount }}</span>
                    </van-col>
                  </van-col>
                  <van-col span="24" class="info-row">
                    <van-col span="12" class="info-label">{{ $t('column.actual_amount_received') }}:</van-col>
                    <van-col span="12" class="info-value">
                      <span v-if="o.user_currency_code">{{ o.user_currency_code }} {{ o.user_local_amount }}</span>
                      <span v-else>${{ o.dollar_amount }}</span>
                     </van-col>
                  </van-col>
                </van-col>
                <!-- 订单金额 -->
                <!-- <van-col span="22" offset="1">
                  <van-col span="24" class="amount-label">{{ $t('column.payment_amount') }}</van-col>
                  <van-col span="24" class="amount-value">{{ o.currency_type_code }} {{ o.cash_amount }}</van-col>
                  <van-col span="18" class="order-id">{{ $t('column.order_id') }}:  <span :id="o.order_id">{{ o.order_id }}</span> <img src="../assets/img/creator/creator_agency_fz.png" @click="copyId(o.order_id)" /> </van-col>
                  <van-col span="6" class="amount-arrow">
                    <img :src="o.payment_method_img"/>
                  </van-col>
                </van-col> -->
                <!-- 收益分配 -->
                <!-- <van-col span="22" offset="1" class="order-item-border-top">
                  <van-col span="8" class="reward-item">
                    <van-col span="24" class="reward-label">{{ $t('column.total') }}</van-col>
                    <van-col span="24" class="reward-value">
                      <img src="../assets/img/coin9.png"/> {{ o.amount_sum }}
                    </van-col>
                  </van-col>
                  <van-col span="8" class="reward-item">
                    <van-col span="24" class="reward-label">{{ $t('other.profit')}}</van-col>
                    <van-col span="24" class="reward-value">
                      <img src="../assets/img/coin9.png"/> {{ o.received_amount }}
                    </van-col>
                  </van-col>
                  <van-col span="8" class="reward-item">
                    <van-col span="24" class="reward-label">{{ $t('column.official_reward') }}</van-col>
                    <van-col span="24" class="reward-value">
                      <img src="../assets/img/coin9.png"/> {{ o.official_amount }}
                    </van-col>
                  </van-col>
                </van-col> -->
                <!-- 倒计时和操作按钮 -->
                <van-col span="22" offset="1" class="order-actions">
                  <van-col span="12" class="countdown-section">
                    <van-icon name="clock-o" color="#ff9500" size="16"  v-if="o.countdown_time"/>
                    <van-count-down :time="o.countdown_time"  v-if="o.countdown_time"/>
                  </van-col>
                  <van-col span="12" class="details-btn-section" v-if="OrderStatusActive === 0">
                    <!--  审核     -->
                    <van-button color="#939393" size="small" plain round @click="cancelOrderSelect(o)">{{ $t('btn.cancel') }}</van-button>
                    <van-button color="#FF61F5" size="small" plain round @click="approveOrder(o)">{{ $t('btn.approve') }}</van-button>
                  </van-col>
                  <van-col span="12" class="details-btn-section" v-else>
                    <!-- 详情按钮 -->
                    <van-button color="#FF61F5" size="small" plain round @click="detailsOrder(o)">{{ $t('column.details') }}</van-button>
                  </van-col>
                </van-col>
              </van-cell>
            </van-list>
          </van-col>
          <van-col span="24" v-else>
            <!-- 无数据状态 -->
            <van-col span="24" class="no-data-content"> <img src="../assets/img/empty_data.png"/> </van-col>
            <van-col span="24" class="no-data-text"> {{ $t('column.no_data')}} </van-col>
          </van-col>
        </van-col>
      </van-col>
          <van-action-sheet v-model="transferShow" :actions="actions" @select="onSelect" :cancel-text="$t('coin_dealer.cancel')"
  close-on-click-action />
      <van-calendar v-model="CalendarShow" :max-range="30" color="#FF61F5" :min-date="minDate" :max-date="maxDate" type="range" position="bottom" @confirm="onConfirmCalendar" />
    </van-row>
  </div>
</template>

<script>
import {Switch, Icon, Dialog} from 'vant'
import Toast from 'vant/lib/toast'
import axios from "axios";
import dayjs from "dayjs";

export default {
  name: 'WithdrawPayroll',
  components: {
    [Switch.name]: Switch,
    [Icon.name]: Icon
  },
  data() {
    return {
      minDate: new Date(2025, 7, 1),
      maxDate: new Date(),
      CalendarText: this.$t('column.last_number_day', {number: 30}),
      CalendarStartDate: '',
      CalendarEndDate: '',
      CalendarShow: false,
      OrderStatusActive: 0,
      OrderStatusList: [
        {id: 0,name: this.$t('column.pending'),count: 0},
        {id: 1,name: this.$t('column.to_be_confirmed'),count: 0},
        {id: 2,name: this.$t('other.success'),count: 0},
        {id: 3,name: this.$t('column.failed'),count: 0}
      ],
      ticket_name: '',
      takeOrderEnabled: false,
      showWarning: true,
      // 订单数据
      orders: [],
      payroll_seller: {
        'user_id': 0,
        'status': 0,
        'payment_amount': undefined,
        'received_amount': undefined,
        'official_amount': undefined,
        'withdrawal_failed_number': undefined,
        'frozen_amount': undefined
      },
      payment_method_list: [],
      loading: false,
      finished: false,
      page: 1,
      transferShow: false,
      actions: [{ id:1,name: this.$t('column.transfer_order') }, { id:2,name: this.$t('column.close_order') }],
      orderId:''
    }
  },
  created() {
   this.get_info()
   this.get_order_list()
  },
  methods: {
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.transferShow = false;
      console.log(item);
      if(item.id === 1){
        this.onClickTransfer()
      }else{
        this.cancelOrder()
      }
    },
    cancelOrderSelect(o) {
      this.orderId = o.order_id
      // this.transferShow = true;
      this.onClickTransfer()
    },
      onClickTransfer() {
      // 转让订单
       Dialog.confirm({
        title: this.$t('column.whether_to_transfer_order'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=transfer_order",{
          params:{
            uid: uid,
            token: token,
            order_id: this.orderId
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.page = 1
                this.orders = []
                this.finished = false
                this.get_info()
                this.get_order_list()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    onConfirmCalendar(date) {
      console.log('Received dates:', date)
      // 格式化日期为 "YYYY-MM-DD"
      const formatDate = (dateObj) => {
        return dayjs(dateObj).format('YYYYMMDD')
      };
      const formatDate1 = (dateObj) => {
        return dayjs(dateObj).format('MM/DD')
      };
      const formattedDate = dayjs().format('YYYYMMDD');
      // 转换日期
      const startDate = formatDate(date[0])
      const endDate = formatDate(date[1])
      const startDate1 = formatDate1(date[0])
      const endDate1 = formatDate1(date[1])
      console.log('Formatted start date:', startDate)
      console.log('Formatted end date:', endDate)
      this.CalendarShow = false
      if(formattedDate === endDate){
        console.log('存在今日日期')
        const days = this.calculateDaysDifference(date)
        this.CalendarText = this.$t('column.last_number_day', {number: days})
      }else{
        this.CalendarText = `${startDate1} - ${endDate1}`
      }
      this.CalendarStartDate = startDate
      this.CalendarEndDate = endDate
      // 这里可以添加使用格式化日期的逻辑--请求接口
      this.get_info()
    },
    // 计算两个日期之间的天数差（包括开始和结束日期）
    calculateDaysDifference(date) {
      const [start, end] = date;
      // 将日期转换为时间戳（毫秒）
      const startTime = start.getTime();
      const endTime = end.getTime();

      // 计算时间差（毫秒）
      const timeDiff = endTime - startTime;
      // 将毫秒转换为天数（1天 = 24 * 60 * 60 * 1000 毫秒）
      return Math.floor(timeDiff / (1000 * 60 * 60 * 24)) + 1;
    },
    onLoad() {
      if (this.page > 1){
        this.get_order_list()
      }
    },
    onInputSwitch(checked) {
      if(this.payment_method_list.length){
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=payroll_seller_order_status_save",{
          params:{
            uid: uid,
            token: token,
            status: checked ? 1 : 0
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            this.takeOrderEnabled = checked
          }else{
            Toast(res.data.error)
          }
        })
      }else{
        // 如果没有绑定支付方式；则需要绑定;跳转到绑定页面
        this.selectPaymentMethod()
      }
    },
    get_info(){
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=payroll_seller_info",{
        params:{
          uid: uid,
          token: token,
          start_times: this.CalendarStartDate,
          end_time: this.CalendarEndDate
        }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status ===1){
          this.payment_method_list = res.data.data.payment_method_list
          this.payroll_seller = res.data.data.payroll_seller
          this.takeOrderEnabled = parseInt(res.data.data.accepting_orders) === 0 ? false : true
          this.ticket_name = res.data.data.ticket_name
          this.OrderStatusList[0].count = res.data.data.pending_number
          this.OrderStatusList[1].count = res.data.data.to_be_confirmed_number
        }else{
          Toast(res.data.error)
        }
      })
    },
    get_order_list() {
      const toast = this.$toast.loading({
        duration: 0, // 持续展示
        forbidClick: true,
        message: this.$t('other.Loading') + '...',
        className: 'custom-loading-toast' // 添加自定义类名
      });
      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=payroll_seller_order_list",{
        params:{
          uid: uid,
          token: token,
          status: this.OrderStatusActive,
          p: this.page
        }
      }).then(res =>{
        toast.clear(); // 关闭加载提示
        if(res.data.status ===1){
          this.loading = false;
          if (this.page === 1) {
            this.orders = []
          }
          for (let j = 0; j < res.data.data.list.length; j++) {
            this.orders.push(res.data.data.list[j])
          }
          //如果列表数据条数< 0，不再触发滚动加载
          if (res.data.data.list.length < 20) {
            this.finished = true
          }
          this.page ++
        }else{
          Toast(res.data.error)
        }
      })
    },
    copyId(creator_user_id) {
      const element = document.getElementById(creator_user_id);
      if (!element) {
        Toast('error');
        return;
      }
      // 创建临时textarea元素用于复制
      const tempTextArea = document.createElement('textarea');
      tempTextArea.value = element.textContent || element.innerText;
      document.body.appendChild(tempTextArea);
      // 选择并复制文本
      tempTextArea.select();
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          Toast(this.$t('column.copy_success'));
          // 添加复制成功效果
          if (this.currentButton) {
            this.currentButton.classList.remove('copied');
          }
          this.currentButton = event.currentTarget;
          this.currentButton.classList.add('copied');
          // 3秒后移除复制成功样式
          setTimeout(() => {
            if (this.currentButton) {
              this.currentButton.classList.remove('copied');
            }
          }, 3000);
        } else {
          Toast('copy error');
        }
      } catch (err) {
        Toast('copy error: ' + err);
      }
      // 移除临时元素
      document.body.removeChild(tempTextArea);
    },
    OrderStatusText(item){
      let name = item.name
      if (item.count > 0) {
        name = name + ' ·' + item.count
      }
      return name
    },
    onClickLeft() {
      const source = this.$route.query.source ? this.$route.query.source : 'app'
      if (source === 'h5') {
        this.$router.go(-1)
      } else {
         window.location.href="bogolive://exit"
      }
     
    },
    showTimeFilter() {
      console.log(dayjs.locale());
      this.CalendarShow = true
    },
    switchTab(name, title) {
      this.page = 1
      this.orders = []
      this.finished = false
      this.OrderStatusActive = name
      this.get_order_list()
    },
    closeWarning() {
      this.showWarning = false
    },
    selectPaymentMethod() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/payroll_seller_payment_method', query: { uid: uid, token: token } })
    },
    cancelOrder() {
      Dialog.confirm({
        title: this.$t('column.is_cancel_order'),
        confirmButtonColor: '#FF61F5',
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const toast = this.$toast.loading({
          duration: 0, // 持续展示
          forbidClick: true,
          message: this.$t('other.Loading') + '...',
          className: 'custom-loading-toast' // 添加自定义类名
        });
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=payroll_seller&act=cancel_payment",{
          params:{
            uid: uid,
            token: token,
            order_id: this.orderId
          }
        }).then(res =>{
          toast.clear(); // 关闭加载提示
          if(res.data.status ===1){
            Toast({
              message: res.data.error,
              duration: 2000, // 持续2秒
              onClose: () => {
                // 这里写Toast关闭后要执行的方法
                this.page = 1
                this.orders = []
                this.finished = false
                this.get_info()
                this.get_order_list()
              }
            })
          }else{
            Toast(res.data.error)
          }
        })
      })
    },
    SearchHref() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/withdraw_payroll_search_order', query: { uid: uid, token: token } })
    },
    approveOrder(o) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/approve_order', query: { uid: uid, token: token, order_id: o.order_id } });
    },
    detailsOrder(o) {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      this.$router.push({ path: '/withdraw_payroll_order', query: { uid: uid, token: token, order_id: o.order_id } })
    }
  }
}
</script>

<style scoped>







</style>



// WEBPACK FOOTER //
// src/components/withdraw_payroll.vue